import React from "react";

const QuotationCustomer = ({ quotation }) => {
  return (
    <>
      {quotation?.introText && (
        <section className="quotation-card">
          <p className="quotation-intro">
            {quotation.introText}
          </p>
        </section>
      )}

      <section className="quotation-two-column">
        <div className="quotation-card">
          <h2>Quotation To</h2>

          <div className="information-block">
            <strong>{quotation?.customerName || "-"}</strong>

            <span>{quotation?.customerEmail || "-"}</span>

            <span>{quotation?.customerAddress || "-"}</span>
          </div>
        </div>

        <div className="quotation-card">
          <h2>Solar Site</h2>

          <div className="information-block">
            <strong>{quotation?.siteName || "-"}</strong>

            <span>{quotation?.siteAddress || "-"}</span>
          </div>
        </div>
      </section>
    </>
  );
};

export default QuotationCustomer;